import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminDataProvider } from "./store/adminDataStore";
import { AdminLangProvider } from "./contexts/AdminLangContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { PhotographerAuthProvider } from "./contexts/PhotographerAuthContext";
import { CustomerAuthProvider } from "./contexts/CustomerAuthContext";
import { ToastProvider } from "./components/base/Toast";
import BetaGate from "./components/feature/BetaGate";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AdminLangProvider>
        <ToastProvider>
          <BetaGate>
            <BrowserRouter basename={__BASE_PATH__}>
              <AdminAuthProvider>
                <AdminDataProvider>
                  <PhotographerAuthProvider>
                    <CustomerAuthProvider>
                      <AppRoutes />
                    </CustomerAuthProvider>
                  </PhotographerAuthProvider>
                </AdminDataProvider>
              </AdminAuthProvider>
            </BrowserRouter>
          </BetaGate>
        </ToastProvider>
      </AdminLangProvider>
    </I18nextProvider>
  );
}

export default App;
